import React, { useState } from "react";

const PnLTable = ({ data, summary }) => {
  const [salesOpen, setSalesOpen] = useState(false);
  const [openService, setOpenService] = useState(null);

  const [expensesOpen, setExpensesOpen] = useState(false);
  const [openExpenseCategory, setOpenExpenseCategory] = useState(null);

  // Group sales by service (ticket, hotel etc.)
  const services = {};

  data.forEach((row) => {
    const service = row.service_type || "Other";
    if (!services[service]) services[service] = [];
    services[service].push(row);
  });

  // Expense Categories including screenshot items
  const expenseCategories = {
    "Cost of Services Sold (COSS)": [
      "Direct Labor",
      "Subcontractor Fees",
      "Project Supplies"
    ],
    "Operating Expenses (OpEx)": [
      "Marketing & Advertising",
      "Office Rent and Utilities",
      "Travel and Entertainment",
      "Technology & Software"
    ],
    "Administrative Expenses": [
      "Professional Fees",
      "Depreciation and Amortization"
    ],
    "Financial Expenses": [
      "Bank Charges"
    ]
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header bg-primary text-white">
        Profit & Loss Report
      </div>

      <div className="card-body">
        <table className="table table-bordered">
          <thead className="table-dark">
            <tr>
              <th>Description</th>
              <th>Amount</th>
            </tr>
          </thead>

          <tbody>
            {/* SALES TOTAL */}
            <tr
              style={{ fontWeight: "bold", cursor: "pointer" }}
              onClick={() => setSalesOpen(!salesOpen)}
            >
              <td>{salesOpen ? "▼" : "▶"} Sales</td>
              <td>{summary.total_revenue}</td>
            </tr>

            {/* SERVICE LEVEL */}
            {salesOpen &&
              Object.keys(services).map((service, i) => {
                const serviceTotal = services[service].reduce(
                  (sum, row) => sum + row.selling_price,
                  0
                );
                return (
                  <React.Fragment key={i}>
                    <tr
                      style={{ background: "#f8f9fa", cursor: "pointer" }}
                      onClick={() =>
                        setOpenService(openService === service ? null : service)
                      }
                    >
                      <td style={{ paddingLeft: "30px" }}>
                        {openService === service ? "▼" : "▶"} {service}
                      </td>
                      <td>{serviceTotal}</td>
                    </tr>

                    {/* SALES DETAILS */}
                    {openService === service &&
                      services[service].map((row, index) => (
                        <tr key={index}>
                          <td style={{ paddingLeft: "70px" }}>
                            {row.customer_name} -{" "}
                            {row.date
                              ? new Date(row.date).toLocaleDateString()
                              : "-"}
                          </td>
                          <td
                            className={
                              row.profit >= 0 ? "text-success" : "text-danger"
                            }
                          >
                            {row.profit}
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                );
              })}

            {/* EXPENSES MAIN */}
            <tr
              style={{ fontWeight: "bold", cursor: "pointer" }}
              onClick={() => setExpensesOpen(!expensesOpen)}
            >
              <td>{expensesOpen ? "▼" : "▶"} Expenses</td>
              <td>{summary.expenses}</td>
            </tr>

            {/* EXPENSE CATEGORY LEVEL */}
            {expensesOpen &&
              Object.keys(expenseCategories).map((category, i) => {
                const categoryTotal = expenseCategories[category].reduce(
                  (sum, item) => sum + (summary.expenses_breakdown?.[item] || 0),
                  0
                );

                return (
                  <React.Fragment key={i}>
                    <tr
                      style={{ background: "#f8f9fa", cursor: "pointer" }}
                      onClick={() =>
                        setOpenExpenseCategory(
                          openExpenseCategory === category ? null : category
                        )
                      }
                    >
                      <td style={{ paddingLeft: "30px" }}>
                        {openExpenseCategory === category ? "▼" : "▶"} {category}
                      </td>
                      <td>{categoryTotal}</td>
                    </tr>

                    {/* SUB ITEMS */}
                    {openExpenseCategory === category &&
                      expenseCategories[category].map((item, index) => (
                        <tr key={index}>
                          <td style={{ paddingLeft: "70px" }}>{item}</td>
                          <td>{summary.expenses_breakdown?.[item] || 0}</td>
                        </tr>
                      ))}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>

        {/* SUMMARY */}
        <div className="mt-4">
          <h5>Summary</h5>
          <table className="table table-bordered w-50">
            <tbody>
              <tr>
                <th>Total Revenue</th>
                <td>{summary.total_revenue}</td>
              </tr>
              <tr>
                <th>Total Cost</th>
                <td>{summary.total_cost}</td>
              </tr>
              <tr>
                <th>Gross Profit</th>
                <td className="text-success">{summary.gross_profit}</td>
              </tr>
              <tr>
                <th>Expenses</th>
                <td>{summary.expenses}</td>
              </tr>
              <tr>
                <th>Net Profit</th>
                <td className="fw-bold text-primary">{summary.net_profit}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PnLTable;
